import { QarepaEnumInformation } from '@qarepa/common';

export enum EmployeeShiftStatusSelectorEnum {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
}

export const EmployeeShiftStatusSelectorArray = [
  EmployeeShiftStatusSelectorEnum.ONLINE,
  EmployeeShiftStatusSelectorEnum.OFFLINE,
];

export const EmployeeShiftStatusSelectorInfo: QarepaEnumInformation<EmployeeShiftStatusSelectorEnum> =
  {
    [EmployeeShiftStatusSelectorEnum.ONLINE]: {
      name: $localize`Empleados trabajando`,
    },
    [EmployeeShiftStatusSelectorEnum.OFFLINE]: {
      name: $localize`Empleados fuera`,
    },
  };
